/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationRemoteSessionClientsList } from "../funcs/organizationRemoteSessionClientsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListOrganizationRemoteSessionClientsRequest,
  ListOrganizationRemoteSessionClientsResponse,
  ListOrganizationRemoteSessionClientsSecurity,
} from "../models/operations/listorganizationremotesessionclients.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type OrganizationRemoteSessionClientsQueryData =
  ListOrganizationRemoteSessionClientsResponse;

export type OrganizationRemoteSessionClientsInfiniteQueryData = PageIterator<
  ListOrganizationRemoteSessionClientsResponse,
  { cursor: string }
>;

export type OrganizationRemoteSessionClientsPageParams = PageIterator<
  ListOrganizationRemoteSessionClientsResponse,
  { cursor: string }
>["~next"];

export function prefetchOrganizationRemoteSessionClients(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListOrganizationRemoteSessionClientsRequest,
  security?: ListOrganizationRemoteSessionClientsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildOrganizationRemoteSessionClientsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchOrganizationRemoteSessionClientsInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListOrganizationRemoteSessionClientsRequest,
  security?: ListOrganizationRemoteSessionClientsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildOrganizationRemoteSessionClientsInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as OrganizationRemoteSessionClientsPageParams,
    getNextPageParam: (
      previousPage: OrganizationRemoteSessionClientsInfiniteQueryData,
    ) => previousPage["~next"],
  });
}

export function buildOrganizationRemoteSessionClientsQuery(
  client$: GramCore,
  request: ListOrganizationRemoteSessionClientsRequest,
  security?: ListOrganizationRemoteSessionClientsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<OrganizationRemoteSessionClientsQueryData>;
} {
  return {
    queryKey: queryKeyOrganizationRemoteSessionClients({
      issuerId: request.issuerId,
      cursor: request.cursor,
      limit: request.limit,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
    }),
    queryFn: async function organizationRemoteSessionClientsQueryFn(
      ctx,
    ): Promise<OrganizationRemoteSessionClientsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(organizationRemoteSessionClientsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildOrganizationRemoteSessionClientsInfiniteQuery(
  client$: GramCore,
  request: ListOrganizationRemoteSessionClientsRequest,
  security?: ListOrganizationRemoteSessionClientsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<
      QueryKey,
      OrganizationRemoteSessionClientsPageParams
    >,
  ) => Promise<OrganizationRemoteSessionClientsInfiniteQueryData>;
} {
  return {
    queryKey: queryKeyOrganizationRemoteSessionClientsInfinite({
      issuerId: request.issuerId,
      cursor: request.cursor,
      limit: request.limit,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
    }),
    queryFn: async function organizationRemoteSessionClientsQuery(
      ctx,
    ): Promise<OrganizationRemoteSessionClientsInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(
          organizationRemoteSessionClientsList(
            client$,
            request,
            security,
            mergedOptions,
          ),
        );
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(
        organizationRemoteSessionClientsList(
          client$,
          {
            ...request,
            cursor: ctx.pageParam.cursor,
          },
          security,
          mergedOptions,
        ),
      );
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeyOrganizationRemoteSessionClients(
  parameters: {
    issuerId: string;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "organizationRemoteSessionClients",
    "list",
    parameters,
  ];
}

export function queryKeyOrganizationRemoteSessionClientsInfinite(
  parameters: {
    issuerId: string;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "organizationRemoteSessionClients",
    "list",
    "infinite",
    parameters,
  ];
}
